export default "__VITE_ASSET__CFkEcH$0__"